import * as _ from "lodash";
import { Spread } from "../../grapecity";
import * as SPIRIT from "../../SPIRIT";

/**
 * Spread基底クラス
 */
export class SpreadBase {

    protected gridMode: SPIRIT.constant.GridMode;

    protected spread: Spread.Sheets.Workbook;

    protected settingInfo;


    /**
     * 
     * @param mode
     */
    constructor(mode: SPIRIT.constant.GridMode) {

        this.gridMode = mode;
    }



    /**
     * spreadメソッドを返却
     * @returns spreadメソッドｌ
     */
    public getSpread() {
        return this.spread;
    }

    /**
     * sheetメソッドを返却
     * @returns spreadメソッドｌ
     */
    public getSheet(pos: string | number) {

        if (_.isNumber(pos)) {
            return this.spread.getSheet(<number>pos);
        } else {
            return this.spread.getSheetFromName(<string>pos);
        }
    }


    /**
     * Spread情報
     * */
    public getSpreadInfo() {
        this.settingInfo.spread = this.spread;
        return this.settingInfo;
    }

    /**
    * Spreadの設定
    * */
    protected setDefaultSpreadSetting(spread: Spread.Sheets.Workbook) {

        // タブ関連
        // シート名編集禁止設定
        spread.options.tabEditable = false;
        // シートタブをドラッグして順序を変更できないように設定
        spread.options.allowSheetReorder = false;
        // タブナビゲーションの非表示設定
        spread.options.tabNavigationVisible = false;
        // タブストリップ幅の比率を設定
        //spread.options.tabStripRatio = 0.5;
        // スクロール関連
        // スクロールバーがアクティブシートの最後の行および列に揃うように設定
        spread.options.scrollbarMaxAlign = true;
        // 表示されるスクロールバーがシートの全体の列数と行数と揃うように設定
        spread.options.scrollbarShowMax = true;
        // その他
        // 貼り付け範囲が足りない場合に貼り付け範囲を拡張する
        spread.options.allowExtendPasteRange = true;

        // Event
        // F2 イベント
        // F2キーの設定
        const manager = spread.commandManager();

        // F2キー押下時にコールされる処理の設定
        const commandF2 = {
            canUndo: true,
            execute: (context, options, isUndo) => {
                const currentSheet = context.getSheetFromName(options.sheetName);
                if (!currentSheet.isEditing()) {
                    //編集開始
                    currentSheet.startEdit();
                }
            }
        };

        // F2キー(キーコード113)に上記の処理"commandF2"を割り当て
        // 引数詳細(https://docs.grapecity.com/help/this.spread-js/sheets/#SpreadJS~GC.Spread.Commands.CommandManager~register.html)
        manager.register("f2Edit", commandF2, 113, false, false, false, false);

    }

    /**
     * 配列内のObjectを比較し、差分があったObjectの配列のみ返却
     * @param src 比較元
     * @param dst 比較先
     */
    // 共通にできるか検討が必要なため一旦呼ばないでください。
    protected getDiff(src, dst, customComparator) {

        //let arrayA = [{ 'id': 1, 'name': '花子' }, { 'id': 2, 'name': '太郎' }, { 'id': 3, 'name': '次郎' }];
        //let arrayB = [{ 'id': 1, 'name': '花子' }];

        //_.differenceWith(arrayA, arrayB, _.isEqual)
        //// [{"id":2,"name":"太郎"},{"id":3,"name":"次郎"}]

        //// こんな感じでも指定できる
        //const customComparator = (a, b) => {
        //    return a.id === b.id && a.name === b.name
        //}
        //_.differenceWith(arrayA, arrayB, customComparator)
        //// [{"id":2,"name":"太郎"},{"id":3,"name":"次郎"}]

        console.log(src);
        console.log(dst);
        // これだとプロパティ数も一致する必要があるので、項目を絞って比較しないと
        // spreadjsの操作でなくなるプロパティ(列定義されていないもの)があるのでダメ。
        //const diff = _.differenceWith(src, dst, _.isEqual);
        const diff = _.differenceWith(src, dst, customComparator);



        console.log(diff);

        // TODO 配列の差は確認できることを確認。
        // もう少し使いやすいように処理も検討が必要。
        // その前にデータソースの確立を優先するため一旦ここまでとする。

        // 共通でなく個別でやってもらうか？

        return diff;
    }

    /**
    * 現在の状態で表示順を設定
    * @param list 現在のGridの状態の配列
    */
    // 共通にできるか検討が必要なため一旦呼ばないでください。
    protected SetOrderNo(list: any[]) {

        //// 名前降順
        //_.orderBy(members, 'name', 'desc'); // => membersが書き換わる

        //// 名前の長さ昇順
        //_.orderBy(members, (item) => {
        //    return item.name.length;
        //}, 'desc');

        //// 名前昇順・作成日降順（名前のほうが優先）
        //_.orderBy(members, ['name', 'created_at'], ['asc', 'desc']);

        // sortBy / orderBy 
        // 関数あるいはプロパティ名で並び替え
        // orderByの方が、昇順降順が選べる
        // 破壊的（元の配列の順番を変えてしまう）なので注意

        // 破壊的のためクローン
        const tmpList = _.cloneDeep(list);



        // 現在の順番でorderNoを変更
        tmpList.forEach((item, index) => {
            const orderNo = index + 1;
            item.OrderNo = orderNo;
        });

        // TODO グループ毎の順番を設定する必要がある

        // 共通でなく個別でやってもらうか？

        return tmpList;
    }


    /**
     * Exportするファイルを作成し、コールバックにSpreadのJSONを返却
     * ※一覧形式のみ対応。マトリックス表現するようなものは個別で実装してください！！！
     * @param url データ取得URL
     * @param sheetName シート名
     * @param colInfos カラム情報（取込区分、システムカラムは除く）
     * @param idColName ID列名
     * @param hasImportUserAuth インポート権限を持つユーザか（trueの場合、取込区分がつく）
     * @param cb ダウンロード処理関数
     */
    protected exportSpreadJsonForMaster(url: string, sheetName: string, colInfos, idColName: string, hasImportUserAuth: boolean, cb) {

        SPIRIT.util.getData(url).then((data) => {

            // 仮DOM
            const $tmp = $('<div></div>');

            // Spread作成
            const spread = new Spread.Sheets.Workbook($tmp[0], { sheetCount: 1 });

            spread.suspendPaint();

            const sheet = spread.getActiveSheet();

            sheet.name(sheetName);
            sheet.autoGenerateColumns = false;
            sheet.setDataSource(data);

            // 取込区分
            const firstFixColInfos = [{ name: 'ImportType', displayName: '取込区分', size: 80 }];
            const firstConcatColInfos = hasImportUserAuth ? firstFixColInfos.concat(colInfos) : colInfos;

            // システムカラム
            const lastColInfos = [
                { name: 'UpdateUserName', displayName: '更新ユーザ名', size: 150 },
                { name: 'UpdateUserLoginId', displayName: '更新ユーザID', size: 100 },
                { name: 'UpdateDateString', displayName: '更新日時', size: 200 },
            ];
            const concatColInfos = firstConcatColInfos.concat(lastColInfos);

            sheet.bindColumns(concatColInfos);

            // 列スタイル設定
            concatColInfos.forEach((item, index) => {

                // 取込区分列のリスト設定
                if (hasImportUserAuth && item.name == 'ImportType') {
                    const dv = Spread.Sheets.DataValidation.createListValidator('追加, 変更, 削除');
                    dv.showErrorMessage(true);
                    // ヘッダ行も設定される（行数指定がないので本来はこうするべき）
                    //sheet.setDataValidator(-1, index, dv, Spread.Sheets.SheetArea.viewport);
                    // ヘッダ行が設定されない方法（行数指定が必要：一旦Excel最大行数は1048576なのでヘッダ数を引いて1048575にする）
                    sheet.setDataValidator(0, 0, 1048575, 1, dv, Spread.Sheets.SheetArea.viewport);
                }

                // 列罫線
                const style = new Spread.Sheets.Style();
                style.borderTop = new Spread.Sheets.LineBorder('#000000', Spread.Sheets.LineStyle.thin);
                style.borderBottom = new Spread.Sheets.LineBorder('#000000', Spread.Sheets.LineStyle.thin);
                style.borderLeft = new Spread.Sheets.LineBorder('#000000', Spread.Sheets.LineStyle.thin);
                style.borderRight = new Spread.Sheets.LineBorder('#000000', Spread.Sheets.LineStyle.thin);

                // ID列の背景色指定
                if (hasImportUserAuth && item.name == idColName) {
                    style.backColor = '#FFFF00';
                } else {
                    // ヘッダー背景色指定
                    const colHeader = sheet.getRange(0, index, 1, 1, Spread.Sheets.SheetArea.colHeader);
                    colHeader.backColor('#E8E8E8');
                }

                sheet.setStyle(-1, index, style, Spread.Sheets.SheetArea.viewport);
            });

            spread.resumePaint();

            const json = spread.toJSON({ includeBindingSource: true, columnHeadersAsFrozenRows: true });

            if (cb != null) {
                cb(json);
            }
        });

    }











    /**
     * 数値型制御用イベント
     * @deprecated
     */
    createNumberArea(row, col, sheet) {
        var cell = sheet.getCell(row, col, Spread.Sheets.SheetArea.viewport);
        cell.hAlign(Spread.Sheets.HorizontalAlign.right);
    }

    /**
     * カレンダー型制御用イベント
     * @deprecated
     */
    createCalenderArea(row, col, sheet) {
        // カレンダードロップダウンリストの作成
        var style = new Spread.Sheets.Style();

        // フォーマットの指定
        style.formatter = "yyyy/MM/dd";
        style.cellButtons = [
            {
                imageType: Spread.Sheets.ButtonImageType.dropdown,
                command: "openDateTimePicker",
                useButtonStyle: false,
            }
        ];
        style.dropDowns = [
            {
                type: Spread.Sheets.DropDownType.dateTimePicker,
                option: {
                    showTime: false,
                    startDay: Spread.Sheets.CalendarStartDay.sunday,
                }
            }
        ];
        // 該当行にセット
        sheet.setStyle(row, col, style);
        var cell = sheet.getCell(row, col, Spread.Sheets.SheetArea.viewport);
        cell.hAlign(Spread.Sheets.HorizontalAlign.right);
    }



    /**
     * 区分列のレイアウトをセットする
     * @deprecated
     */
    setSectionTypeLayout(sheet, contentRow) {
        // 区分列の色を変更
        var cell = sheet.getCell(contentRow, 0, Spread.Sheets.SheetArea.viewport);
        cell.backColor("#e6e6e6");
        cell.foreColor("#3f3f3f");
        cell.borderBottom(new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.medium));
        cell.borderRight(new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.medium));
    }
















    /**
     * 
     */
    getColumnRange(col, sheet: Spread.Sheets.Worksheet): Spread.Sheets.CellRange {
        return sheet.getRange(-1, col, -1, 1);
    }

    /**
     * 
     */
    getColumnStyle(col, sheet: Spread.Sheets.Worksheet): Spread.Sheets.Style {
        return sheet.getStyle(-1, col) || new Spread.Sheets.Style();
    }

    /**
     * 
     */
    setColumnStyle(col, style: Spread.Sheets.Style, sheet: Spread.Sheets.Worksheet, sheetArea?: Spread.Sheets.SheetArea) {
        return sheet.setStyle(-1, col, style, sheetArea);
    }


    /**
     * 数値型カラム
     * 
     * @param col
     * @param sheet
     */
    createNumberColumn(col, sheet: Spread.Sheets.Worksheet) {
        var colRange = this.getColumnRange(col, sheet);
        colRange.hAlign(Spread.Sheets.HorizontalAlign.right);
    }

    /**
     * カレンダー型カラム
     * 
     * @param col
     * @param sheet
     */
    createCalenderColumn(col, sheet: Spread.Sheets.Worksheet) {
        // カレンダードロップダウンリストの作成
        var style = new Spread.Sheets.Style();

        // フォーマットの指定
        style.formatter = "yyyy/MM/dd";
        style.cellButtons = [
            {
                imageType: Spread.Sheets.ButtonImageType.dropdown,
                command: "openDateTimePicker",
                useButtonStyle: false,
            }
        ];
        style.dropDowns = [
            {
                type: Spread.Sheets.DropDownType.dateTimePicker,
                option: {
                    showTime: false,
                    startDay: Spread.Sheets.CalendarStartDay.sunday,
                }
            }
        ];


        //// 該当行にセット
        //sheet.setStyle(row, col, style);
        //var cell = sheet.getCell(row, col, Spread.Sheets.SheetArea.viewport);
        //cell.hAlign(Spread.Sheets.HorizontalAlign.right);

        //// スタイルを列に設定します。
        //sheet.setStyle(-1, col, style, Spread.Sheets.SheetArea.viewport)

        // Rangeで指定スタイルを列に設定します。
        //var colRange = sheet.getRange(-1, col, -1, 1);
        var colRange = this.getColumnRange(col, sheet);

        colRange.formatter("yyyy/MM/dd");
        colRange.cellButtons(style.cellButtons);
        colRange.dropDowns(style.dropDowns);
        colRange.locked(false);
    }


    /**
     * 
     * @param col
     * @param sheet
     */
    setSectionTypeColumnStyle(col, sheet: Spread.Sheets.Worksheet) {


        //旧
        //// 区分列の色を変更
        //var cell = sheet.getCell(contentRow, 0, Spread.Sheets.SheetArea.viewport);
        //cell.backColor("#e6e6e6");
        //cell.foreColor("#3f3f3f");
        //cell.borderBottom(new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.medium));
        //cell.borderRight(new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.medium));


        // ①スタイルを列に設定します。
        //var style = this.getColumnStyle(col, sheet);
        //style.backColor = "#e6e6e6";
        //style.foreColor = "#3f3f3f";
        //style.borderBottom = new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.medium);
        //style.borderRight = new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.medium);
        //this.setColumnStyle(col, style, sheet);


        // ②Range
        var colRange = this.getColumnRange(col, sheet);
        colRange.backColor("#e6e6e6");
        colRange.foreColor("#3f3f3f");
        colRange.borderBottom(new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.thin));
        colRange.borderRight(new Spread.Sheets.LineBorder("#999", Spread.Sheets.LineStyle.thin));

        //権限に応じて非表示にする
        if (this.gridMode == SPIRIT.constant.GridMode.EDIT) {
            colRange.visible(true);
        } else {
            colRange.visible(false);
        }
    }



   /**
    * 指定のカラムにshowEllipsis(...)を設定
    * @param col
    * @param sheet
    * @param value
    */
    showColumnEllipsis(col, sheet: Spread.Sheets.Worksheet, value: boolean) {
        var colRange = this.getColumnRange(col, sheet);
        colRange.showEllipsis(value);
    }


}


/**
 * Sheet
 */
export class SpreadSheet {



}

